import { env } from "../../config/env";
import { sfctcvOAuth } from "./sfctcv.oauth";

const OauthRoomsStaging = [
  {
    name: "SFCTCV",
    id: "694bf80dba61f5a3c470d095",
    manager: sfctcvOAuth,
  },
];

const OauthRoomsProduction = [
  {
    name: "SFCTCV",
    id: "688cab068ec73b014f8f6d33",
    manager: sfctcvOAuth,
  },
];

export const OauthRoomsConfig =
  env.appEnv === "production" ? OauthRoomsProduction : OauthRoomsStaging;
